<script>
    import AppIcon from "../icons/AppIcon.svelte";
    import {setFocusTo} from "../../lib/lib";

    export let id = '';
    export let value = '';
    export let placeholder = '';

    let viewPassword = false;

    const togglePassword = () => {
        viewPassword = !viewPassword;
        setFocusTo(id);
    }
</script>
<div class="password-control">
    {#if viewPassword}
        <input type="text" class="form-control" id="{ id }" name="password" bind:value="{ value }" {placeholder}
               required>
    {:else}
        <input type="password" class="form-control" id="{ id }" name="password" bind:value="{ value }" {placeholder}
               required>
    {/if}
    <div class="toggler" class:active={ viewPassword } on:click="{ togglePassword }">
        <AppIcon icon="eye-solid" size="18"/>
    </div>
</div>

<style>
    .password-control {
        position: relative;
    }

    .password-control .toggler {
        position: absolute;
        top: 50%;
        right: 4px;
        transform: translateY(-50%);
        color: #8e9db1;
        border-radius: 50%;
        padding: 7px;
        cursor: pointer;
    }
    .password-control .toggler:hover, .password-control .toggler.active {
        background: #f5f5f5;
    }
</style>